type stages = {
  pro?: boolean;
  staging?: boolean;
  dev?: boolean;
  local?: boolean;
};

const getToggle = ({
  pro = true,
  dev = true,
  staging = true,
  local = false,
}: stages = {}): boolean => {
  switch (process.env.STAGE) {
    case 'pro':
      return pro;
    case 'staging':
      return staging;
    case 'dev':
      return dev;
    case 'local':
      return local;
    default:
      return true;
  }
};

export default getToggle;
